module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-3-photo-2-ab7f0763ade2cbe863322c3b0b4e0c59.webp";